import axios, { AxiosError, AxiosResponse } from "axios"
import { SnackbarUtilities } from "../utilidades/Snackbar"
import { WSLogout } from "../modules/auth/api/authApi";
import { callLogout } from "../api/logoutHelper";

const extractAxiosMessage = (data: any): string | undefined => {

  if (!data) {
    return undefined;
  }
  if (typeof data === 'string') {
    return data;
  }
  if (typeof data === 'object') {
    const obj: any = data;
    if (typeof obj.message === 'string') {
      return obj.message;
    }
    if (typeof obj.error_description === 'string') {
      return obj.error_description;
    }
    if (typeof obj.error === 'string') {
      return obj.error;
    }
    if (Array.isArray(obj.errors)) {
      const items = obj.errors
        .map((it: any, idx: number) => {
          return typeof it === 'string' ? it : it?.message;
        })
        .filter(Boolean);
      if (items.length) {
        const joined = items.join(' • ');
        return joined;
      }
    }
  }
  console.groupEnd();
  return undefined;
};

export const responseInterceptorSuccess = async (response: AxiosResponse<any, any>) => {
  // ⚠️ Ignorar blobs
  if (response.config.responseType === 'blob') return response;

  try {
    const data = response.data;
    const message = extractAxiosMessage(data);
    if (message) SnackbarUtilities.success(message);
  } catch (err) {
    console.warn("[Interceptor][Success] No se pudo procesar mensaje:", err);
  }

  return response;
};

export const responseInterceptorError = (error: unknown) => {

  // 1) Si no es AxiosError → mensaje genérico
  if (!axios.isAxiosError(error)) {
    SnackbarUtilities.error("Error desconocido");
    return Promise.reject(error);
  }

  // 2) Es AxiosError: unifiquemos datos
  const e: AxiosError = error;
  const status = e.response?.status;
  const data = e.response?.data;
  const backendMsg = extractAxiosMessage(data);
  const fallbackMsg =
    e.message === "Network Error" || e.code === "ERR_NETWORK"
      ? "No se pudo conectar con el servidor. Revisa tu red e intenta nuevamente."
      : e.message;

  // 3) Reglas por status primero
  if (status === 401) {
    SnackbarUtilities.error("Sesión expirada, por favor inicia sesión de nuevo.");
    try {
      callLogout(); 
      WSLogout();
    } catch (logoutErr) {
      console.warn("[Interceptor][Logout] falló:", logoutErr);
    }
    return Promise.reject(e);
  }

  if (typeof status === "number" && status >= 500) {
    SnackbarUtilities.error("Error en el servidor, intente en unos minutos");
    return Promise.reject(e);
  }

  // 4) Para el resto: mostrar mensaje del backend si existe; sino fallback
  SnackbarUtilities.error(backendMsg || fallbackMsg || "Error desconocido, intente mas tarde");
  return Promise.reject(e);
};